class DoubieCharmOptions extends HTMLElement {
  connectedCallback() {
    this.attachmentInputs = Array.from(this.querySelectorAll('input[name="doubie-attachment"]'));
    this.personalisationInput = this.querySelector('[data-personalisation-toggle]');
    this.initialInput = this.querySelector('[data-initial-input]');
    this.coffeeInput = this.querySelector('[data-coffee-toggle]');
    this.goldOptions = this.querySelector('[data-gold-options]');

    this.addEventListener('input', this.stopOptionEvent);
    this.addEventListener('change', this.handleChange);
    this.initialInput?.addEventListener('input', this.handleInitialInput);
    this.updateForVariant(this.dataset.variantTitle || '');
  }

  disconnectedCallback() {
    this.removeEventListener('input', this.stopOptionEvent);
    this.removeEventListener('change', this.handleChange);
    this.initialInput?.removeEventListener('input', this.handleInitialInput);
  }

  stopOptionEvent = (event) => {
    event.stopPropagation();
  };

  handleChange = (event) => {
    // Keep add-on controls from triggering the theme's product-variant refresh.
    // That refresh would replace this component and reset the customer's choice.
    event.stopPropagation();
    this.syncState();
  };

  handleInitialInput = () => {
    if (!this.initialInput) return;
    this.initialInput.value = this.initialInput.value.replace(/[^a-z]/gi, '').slice(0, 1).toUpperCase();
  };

  updateForVariant(variantTitle = '') {
    const isMagnet = variantTitle.toLowerCase().includes('magnet');
    this.hidden = isMagnet;
    this.dataset.isMagnet = String(isMagnet);

    if (isMagnet) {
      const brownCord = this.querySelector('input[name="doubie-attachment"][value="Brown suede cord"]');
      if (brownCord) brownCord.checked = true;
      if (this.personalisationInput) this.personalisationInput.checked = false;
      if (this.coffeeInput) this.coffeeInput.checked = false;
      if (this.initialInput) this.initialInput.value = '';
    }

    this.syncState();
  }

  syncState() {
    const attachment = this.querySelector('input[name="doubie-attachment"]:checked')?.value;
    const isGold = attachment === 'Gold metal ring';
    const wantsPersonalisation = isGold && Boolean(this.personalisationInput?.checked);

    if (this.goldOptions) this.goldOptions.hidden = !isGold;
    if (this.personalisationInput) this.personalisationInput.disabled = !isGold;
    if (this.coffeeInput) this.coffeeInput.disabled = !isGold;

    if (this.initialInput) {
      this.initialInput.hidden = !wantsPersonalisation;
      this.initialInput.disabled = !wantsPersonalisation;
      this.initialInput.required = wantsPersonalisation;
      if (!wantsPersonalisation) this.initialInput.value = '';
    }
  }

  getCartConfiguration(quantity = 1) {
    if (this.hidden || this.dataset.isMagnet === 'true') return null;

    const attachment = this.querySelector('input[name="doubie-attachment"]:checked')?.value || 'Brown suede cord';
    const isGold = attachment === 'Gold metal ring';
    const wantsPersonalisation = isGold && Boolean(this.personalisationInput?.checked);
    const wantsCoffee = isGold && Boolean(this.coffeeInput?.checked);
    const initial = wantsPersonalisation ? this.initialInput?.value.trim().toUpperCase() : '';

    if (wantsPersonalisation && !/^[A-Z]$/.test(initial)) {
      this.initialInput?.setCustomValidity('Please enter one English letter from A to Z.');
      this.initialInput?.reportValidity();
      return { invalid: true };
    }

    this.initialInput?.setCustomValidity('');

    const baseProperties = { Attachment: attachment };
    if (initial) baseProperties['Personalised initial'] = initial;
    if (wantsCoffee) baseProperties['Coffee charm'] = 'Added';

    const sharedProperties = {
      _doubie_add_on: 'true',
      _doubie_parent_product: this.dataset.productTitle || 'Real Bread Bag Charm',
    };
    const addOnItems = [];

    if (isGold) {
      addOnItems.push({
        id: Number(this.dataset.goldRingVariantId),
        quantity,
        properties: { ...sharedProperties, For: this.dataset.productTitle || 'Bag charm' },
      });
    }
    if (initial) {
      addOnItems.push({
        id: Number(this.dataset.initialVariantId),
        quantity,
        properties: { ...sharedProperties, For: this.dataset.productTitle || 'Bag charm', Initial: initial },
      });
    }
    if (wantsCoffee) {
      addOnItems.push({
        id: Number(this.dataset.coffeeVariantId),
        quantity,
        properties: { ...sharedProperties, For: this.dataset.productTitle || 'Bag charm' },
      });
    }

    return { baseProperties, addOnItems };
  }
}

if (!customElements.get('doubie-charm-options')) {
  customElements.define('doubie-charm-options', DoubieCharmOptions);
}
